<template>
  <div class="bm-player-edit" v-cloak >
    <div class="header" >
      <div class="title">{{match.name}}</div>
      <div class="team-box">
        <div class='left'>
          <div class='name'>
            <div>
              <img class="logo" v-if="team.badge" :src="teamLogo" >
              <img class="logo" v-else src="@/assets/images/team-logo-empty.png" />
            </div>
            <div class="team-name">{{team.name}}</div>
          </div>
        </div>
      </div>
      <div class='infotext'>请填写参赛信息</div>
    </div>
    <div class="sign-form">
      <van-cell-group>
        <van-field v-model="player.number" label="球衣号" placeholder="请输入球衣号"/>
        <van-field v-model="player.mobile" label="手机号" placeholder="请输入手机号"/>
      </van-cell-group>
      <div class="bm-cell" v-if="infoSetting['insureFile'].default">
        <van-cell title-class="editable" title="运动意外险保单材料" :border="false">
          <template>
            <div class="teamIcon imgIcon">
              <van-uploader class="uploader" :after-read="onReadInsure">
                <img v-if="insureImg" :src="insureImg" alt="">
                <i v-else class="van-icon van-icon-photograph van-uploader__upload-icon"></i>
              </van-uploader>
            </div>
          </template>
        </van-cell>
        <div class="note-label" v-html="infoSetting['insureFile'].instruction"></div>
      </div>
      <div class='next-btn'>
        <van-button  @click="doSubmit" type="primary" block>提交</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import { getQiniuUploadToken } from '@/api/user'
import { getAssociationMatchPlayerSignupInfo, associationPlayerSignupMatch } from '@/api/team'
import { getBMMatchSignUpRule } from '@/api/match'
import { ImageFormat, varConfig } from '@/utils/'
import { getUserInfo } from '@/libs/cookie-storage'

import {Cell, CellGroup, Button, SwipeCell, Dialog, Toast} from 'vant'

Vue.use(Cell).use(CellGroup).use(Button).use(SwipeCell).use(Dialog).use(Toast)
const setting = {
  insureFile: {
    value: 'insureFile',
    default: false,
    alias: 'insureFile'
  }
}
const defaultMatch = {name: '', id: ''}
const defaultAssociation = {name: '', id: ''}
const defaultTeam = {name: '', id: '', badge: ''}
const defaultPlayer = {
  trueName: '',
  id: '',
  isTeamLeader: '',
  auditProgress: 0,
  signupAlready: '0',
  serialNumber: '',
  number: '',
  certNo: '',
  birthday: ''
}

export default {
  name: 'PlayerEdit',
  data() {
    return {
      matchId: '',
      teamId: '',
      insureImg: '',
      infoSetting: {
        insureFile: {
          value: 'insureFile',
          default: false,
          alias: 'insureFile'
        }
      },
      match: defaultMatch,
      association: defaultAssociation,
      team: defaultTeam,
      player: defaultPlayer
    }
  },
  computed: {
    teamLogo() {
      return ImageFormat.imageView(this.team.badge, 104, 104)
    }
  },
  created() {
  },
  mounted() {
    this.teamId = this.$route.query.teamId
    this.matchId = this.$route.query.matchId
    this.player.playerId = this.$route.query.playerId
    this.player.number = this.$route.query.number
    this.player.mobile = this.$route.query.mobile
    this.player.forSelf = this.$route.query.forSelf
    this.player.insureFile = this.$route.query.insureFile
    if (this.player.insureFile) {
      this.insureImg = ImageFormat.squareImageView(this.player.insureFile, 100)
    }
    this.getAssociationMatchPlayerSignupInfo()
    this.getQiniuToken()
    this.getBMMatchSignUpRule()
  },
  methods: {
    getAssociationMatchPlayerSignupInfo() {
      const userInfo = getUserInfo()
      const params = {
        matchId: this.matchId,
        teamId: this.teamId
      }
      if (userInfo.id) {
        params.userId = userInfo.id
      }
      getAssociationMatchPlayerSignupInfo(params).then((response) => {
        if (response) {
          this.match = response.data.match
          this.association = response.data.association
          this.team = response.data.team
          this.player.isTeamLeader = response.data.player.isTeamLeader
        }
      })
    },
    associationPlayerSignupMatch() {
      const params = {
        matchId: this.matchId,
        teamId: this.teamId,
        playerId: this.player.playerId,
        number: this.player.number,
        mobile: this.player.mobile,
        insureFile: this.player.insureFile
      }
      if (this.player.isTeamLeader === '1') { // 当前账号是否为队长
        params.forSelf = this.player.forSelf
      }
      associationPlayerSignupMatch(params).then((response) => {
        if (response) {
          Dialog.alert({
            message: '报名成功'
          }).then(() => {
            // on close
            this.$router.push({
              path: '/participate/player-apply',
              query: {
                teamId: this.teamId,
                matchId: this.matchId
              }
            })
          })
        }
      })
    },
    doSubmit() {
      if (this.player.number.length < 1 || this.player.mobile.length < 1) {
        Toast('用户填写信息不能为空')
        return
      }
      this.associationPlayerSignupMatch()
    },
    onReadInsure(file) {
      this.uploadFile(file).then(res => {
        if (res) {
          this.player.insureFile = res.hash
          this.insureImg = ImageFormat.squareImageView(res.hash, 100)
        }
      })
    },
    uploadFile(file) {
      let formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      let config = {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
      return new Promise((resolve, reject) => {
        axios.post(varConfig.qiniuUpload, formData, config).then(res => {
          const data = res.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getQiniuToken() {
      getQiniuUploadToken().then(response => {
        const data = response.data
        this.qiniuToken = data.token
      }).catch(err => {
        console.log(err)
        Toast('七牛Token获取失败')
      })
    },
    getBMMatchSignUpRule() {
      getBMMatchSignUpRule(this.matchId).then(response => {
        if (response) {
          this.popupLoading.clear()
          const signUpRuleV2 = response.data.signUpRuleV2
          signUpRuleV2.forEach(reg => {
            const ret = setting[reg.field]
            if (ret) {
              ret.default = true
              ret.instruction = reg.instruction
              this.infoSetting[reg.field] = ret
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.bm-player-edit{
  padding: 15px;
  .header{
    .title{
      padding-top: 20px;
      font-size: 16px;
      text-align: center;
    }
    .team-box{
      font-size: 14px;
      position: relative;
      margin-top: 15px;
      .left{
        float: left;
        .logo {
          width: 52px;
          height: 52px;
          border-radius: 4px;
        }
      }
      .right{
        float: right;
        padding-top: 25px;
      }
      .name{
        padding-top: 20px;
        font-size: 14px;
        text-align: left;
      }
      .team-name {
        position: absolute;
        top: 36px;
        left: 60px;
        width: 220px;
      }
    }
    .infotext{
      text-align: left;
      margin-top: 20px;
      font-size: 12px;
      padding: 15px 0;
      clear: both;
      padding-left: 15px;
    }
  }
  .sign-form{
    .infotext{
      font-size: 10px;
      text-align: center;
      margin: 10px;
    }
    .radio{

    }
    .next-btn{
      padding: 10px;
      margin-top: 10px;
      text-align: center;
      .next{

      }
    }
  }

  .teamIcon {
    width: 50px;
    height: 50px;
    background:rgba(230,230,230,1);
    border-radius:50px;
    float: right;
    position: relative;
    img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background-color: white;
    }
    .upload-profile-lod {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: white;
      .van-loading {
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  .imgIcon {
    border-radius: 0;
    background-color: #f7f8fa;
    .van-uploader__upload-icon {
      color: #dcdee0;
      font-size: 20px;
      position: relative;
      top: 15px;
      right: 15px;
    }
    img {
      border-radius: 0;
    }
  }

  .bm-cell {
    .note-label {
      white-space:pre-line;
      font-size: 12px;
      color: #969799;
      padding: 4px 0;
      border-bottom: 1px solid #f6f6f6;
      margin: 0 15px;
    }
  }

  #bm-player-edit .van-cell-group .van-cell .van-icon::before {
    color: #dcdee0;
  }

  #bm-player-edit .van-uploader {
    position: relative;
    display: inline-block;
    height: 100%;
    width: 100%;
  }

  #bm-player-edit .van-button--plain.van-button--info {
    padding: 0 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/team/participate/player-edit.vue